import styled from "@emotion/styled";

export const Bold18 = `
  font-size: 18px;
  font-weight: 700 !important;
  font-family: PretendardGOV-Bold;
`;

export const Bold16 = `
  font-size: 16px;
  font-weight: 700 !important;
  font-family: PretendardGOV-Bold;
`;

export const SemiBold26 = `
  font-size: 26px;
  font-weight: 600 !important;
  font-family: PretendardGOV-SemiBold;
`;

export const SemiBold20 = `
  font-size: 20px;
  font-weight: 600 !important;
  font-family: PretendardGOV-SemiBold;
`;

export const SemiBold14 = `
  font-size: 14px;
  font-weight: 600 !important;
  font-family: PretendardGOV-SemiBold;
`;

export const Medium20 = `
  font-size: 20px;
  font-weight: 500 !important;
  font-family: PretendardGOV-Medium;
`;

export const Medium19 = `
  font-size: 19px;
  font-weight: 500 !important;
  font-family: PretendardGOV-Medium;
`;

export const Medium18 = `
  font-size: 18px;
  font-weight: 500 !important;
  font-family: PretendardGOV-Medium;
`;

export const Medium17 = `
  font-size: 17px;
  font-weight: 500 !important;
  font-family: PretendardGOV-Medium;
`;

export const Regular19 = `
  font-size: 19px;
  font-weight: 400 !important;
  font-family: PretendardGOV-Regular;
`;

export const Regular18 = `
  font-size: 18px;
  font-weight: 400 !important;
  font-family: PretendardGOV-Regular;
`;

export const Regular17 = `
  font-size: 17px;
  font-weight: 400 !important;
  font-family: PretendardGOV-Regular;
`;

export const Regular16 = `
  font-size: 16px;
  font-weight: 400 !important;
  font-family: PretendardGOV-Regular;
`;

export const Wrapper = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 20px;
`;
